import { ValueComponent, ValueComponentDefinition } from "components/components/Component";
import { TableColumn } from "../ColumnDefinitions";

/**
 * A virtual component that is backed by a table column definition.
 * 
 * It is used to apply changes to column cells on actions and dependencies.
 */
export class DataCellComponent implements ValueComponent {
    private column: TableColumn;
    definition: ValueComponentDefinition;
    componentType: "dataCellComponent";
    id: string;
    private view: HTMLElement;

    constructor(column: TableColumn, view: HTMLElement) {
        this.column = column;
        this.view = view;
        this.definition = {
            id: "dataCellComponent" + column.property,
            componentType: "dataCellComponentc",
            property: column.property
        };
    }

    render(): Element {
        throw new Error("Method not implemented.");
    }
    getValue() {
        throw new Error("Method not implemented.");
    }

    value(data: any): void {
        let rendered = this.column.render(data, "display", []);
        this.view.innerHTML = rendered;
    }

    public static dataCellComponents(columns, cell:HTMLTableCellElement): DataCellComponent[] {
        let tr = cell.closest("tr");
        let tds = Array.from(tr.querySelectorAll("td"));
        console.log(columns)
        let components = [];
        for (let index = 0; index < columns.length; index++) {
            const column = columns[index] as TableColumn ;
            if (column.definition.type !== "ComponentColumn") {
                components.push(new DataCellComponent(column, tds[index]));
            }
            
        }
        return components;
    }
}
